import { P2GBox, P2GDivider, P2GCheckBoxLegacy } from '@parcel2go/core-ui';
import { Fragment, ReactNode } from 'react';

export interface props {
  items: {
    value: string;
    text: string | ReactNode;
  }[];
  selected: string[];
  onSelect: (val: string) => void;
  textAlign?: 'left' | 'center' | 'right';
}

const DropList: React.FC<props> = (props) => {
  if (!props.items || props.items.length === 0) {
    return null;
  }

  return (
    <P2GBox bordered mt={2} textAlign={props.textAlign}>
      {props.items.map((x, i) => {
        return (
          <Fragment key={`${x.value}`}>
            {i > 0 && <P2GDivider />}
            <P2GBox pl={2} pr={2}>
              <P2GCheckBoxLegacy
                checked={props.selected.includes(x.value)}
                onChange={() => props.onSelect(x.value)}
                label={x.text}
                id={`multi_${i}`}
                labelPlacement="end"
                variant="primary"
                error={false}
              />
            </P2GBox>
          </Fragment>
        );
      })}
    </P2GBox>
  );
};

export default DropList;
